<template>
  <SearchHistory
    v-if="isModalOpen"
    v-model:search-query="searchQuery"
    v-model:is-modal-open="isModalOpen"
  />
  <main class="search-page layout-centered">
    <header>
      <h1 class="search-page__title">
        {{ t("header") }}
      </h1>
    </header>

    <div class="search-page__content">
      <div class="top-container">
        <p>
          {{ t("topText") }}
        </p>
      </div>

      <div class="middle-container">
        <div class="search-page__selector">
          <div class="f-field">
            <select
              id="searchDomain"
              v-model="selectedDomain"
              class="f-field__input f-field__input--select search-domain-selector"
              :class="{ 'f-field__input--is-filled': selectedDomain }"
              name="searchDomain"
            >
              <option
                v-for="option in searchDomains"
                :key="`search-type-${option}`"
                :value="option"
              >
                {{ t(`searchDomain.${option}`) }}
              </option>
            </select>
          </div>
        </div>
        <div class="search-page__search-area">
          <form
            role="search"
            class="f-field-search inline-block-child"
            @submit.prevent
            @focusin="isSearchFocused = true"
            @focusout="isSearchFocused = false"
            @keydown.up.exact.prevent.stop="selectPreviousOption"
            @keydown.down.exact.prevent.stop="selectNextOption"
            @keydown.esc.exact.prevent.stop="searchQuery = ''"
          >
            <!--@submit.prevent blocks browser's default submit therefore preventing duplicate history entries-->
            <button
              type="submit"
              class="f-field-search__submit"
              :aria-label="t('search')"
              @click.prevent="performSearch(searchQuery, selectedDomain)"
            />
            <input
              ref="searchInput"
              v-model="searchQuery"
              :placeholder="t('search...')"
              type="text"
              role="combobox"
              :aria-expanded="String(!isListboxHidden)"
              class="f-field-search__input f-field-search__input--card search-input"
              aria-controls="search-listbox"
              :aria-activedescendant="`search-listbox-option-${selectedDomain}`"
              @keyup.enter="performSearch(searchQuery, selectedDomain)"
            ><!--Listen for the key being released instead of pressed to also prevent duplicate history entries-->

            <!-- <button
              type="history"
              style="width: 2.5rem; height: 2.5rem;"
              :aria-label="Save_Query"
              @click.prevent="saveHistory()"
            >
              <svg
                width="30"
                height="30"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.6686 2H2.8C2.35817 2 2 2.35817 2 2.8V21.2C2 21.6418 2.35817 22 2.8 22H21.2C21.6418 22 22 21.6418 22 21.2V6.33137C22 6.1192 21.9157 5.91571 21.7657 5.76569L18.2343 2.23431C18.0843 2.08429 17.8808 2 17.6686 2Z"
                  stroke="#45555f"
                  stroke-width="1.75"
                />
                <circle
                  cx="12"
                  cy="16"
                  r="4"
                  fill="#45555f"
                />
                <rect
                  x="4"
                  y="4"
                  width="9"
                  height="4"
                  fill="#45555f"
                />
              </svg>
            </button> -->
            <!--For future implementation of bookmarked searches that connects to backend-->

            <button
              type="history"
              class="history-btn"
              :aria-label="History"
              @click.prevent="showHistory()"
            >
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M16.0001 18L20.0001 22L16.0001 18Z"
                  fill="#45555f"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M16.0001 18L16.0001 11.0078L16.0001 18Z"
                  fill="#45555f"
                />
                <path
                  d="M11.001 12.7089L4.09326 12.709L4.09229 5.81331M5.96091 11.5905C8.79742 5.9256 15.6299 3.60306 21.2216 6.40294C26.8133 9.20283 29.0469 16.0649 26.2104 21.7298C23.3739 27.3946 16.5414 29.7172 10.9497 26.9173C9.48592 26.2989 6.29199 24.2628 5.22634 21.0658M20.0001 22L16.0001 18L16.0001 11.0078"
                  stroke="#45555f"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
          </form>
        </div>
      </div>
      <div class="bottom-container">
        <div
          class="f-field f-field--toggle"
          style="margin: 0"
        >
          <div
            v-show="selectedDomain === 'records'"
            class="advanced-search"
          >
            <input
              id="advancedSearchOperator"
              v-model="useStringQuery"
              type="checkbox"
              class="f-field__input--toggle"
            >
            <div class="f-field__toggle" />
            <label
              for="advancedSearchOperator"
              class="advanced-search__text"
            >
              {{ t('advancedSearch') }}
            </label>
          </div>
        </div>
        <div>
          <RouterLink
            :to="{ name: 'ExploreUnitsPage' }"
            class="btn--link btn--fake-link"
          >
            {{ t('exploreUnits')+ " >" }}
          </RouterLink>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { useI18n } from 'vue-i18n'
import { mapState } from 'vuex'
import { useHeadSafe } from '@unhead/vue'
import SearchHistory from '#src/components/SearchHistory.vue'

export default {
  components: {
    SearchHistory
  },
  setup() {
    const { t } = useI18n({
      fallbackWarn: false,
      silentTranslationWarn: true,
      silentFallbackWarn: true,
      messages: {
        pt: {
          title: 'Pesquisar',
          description: 'Pesquise por publicações autores ou unidades no repositório',
          topText: 'O que quer pesquisar?',
          header: 'Repositório de Documentos Cientifícos',
          searchMessage: 'Selecionar um campo',
          deselect: 'Limpar seleção',
          'search...': 'Pesquisar...',
          advancedSearch: 'Procurar usando expressões estruturadas',
          exploreUnits: 'Explorar Unidades de Investigação',
          advanceSearch: 'Pesquisa Avançada',
          searchDomain: {
            records: 'Publicações',
            authors: 'Autores',
            units: 'Instituições/Unidades de Investigação'
          }
        },
        en: {
          title: 'Search',
          description: 'Search for users, authors or units inside the repository',
          topText: 'What do you want to search?',
          header: 'Repository of Scientific Documents',
          searchMessage: 'Select a field',
          deselect: 'Clear selection',
          'search...': 'Search...',
          advancedSearch: 'Search using advanced search',
          exploreUnits: 'Explore Research Units',
          advanceSearch: 'Advanced Search',
          searchDomain: {
            records: 'Publications',
            authors: 'Authors',
            units: 'Institutions/Research Units'
          }
        }
      }
    })
    const metaInfo = {
      title: t('title'),
      meta: [{ name: 'description', content: t('description') }]
    }
    useHeadSafe(metaInfo)
    return { t }
  },
  data() {
    return {
      isSearchFocused: false,
      searchQuery: '',
      selectedDomain: 'records',
      useStringQuery: false,
      isModalOpen: false,
      queries: []
    }
  },
  computed: {
    ...mapState(['configuration']),
    searchDomains() {
      return ['records', 'authors', 'units']
    },
    isEmptyQuery() {
      return !this.searchQuery || this.searchQuery.length === 0
    },
    isListboxHidden() {
      return this.isEmptyQuery || !this.isSearchFocused
    }
  },
  mounted() {
    const allQueries = JSON.parse(localStorage.getItem('queries')) || []
    this.queries = allQueries.reverse() // server side rendering, yay.
  },
  methods: {
    focusOn(ref) {
      ref.focus()
    },
    selectPreviousOption() {
      const index = Math.max(
        0,
        this.searchDomains.indexOf(this.selectedDomain) - 1
      )
      this.selectedDomain = this.searchDomains[index]
    },
    selectNextOption() {
      const index = Math.min(
        this.searchDomains.length - 1,
        this.searchDomains.indexOf(this.selectedDomain) + 1
      )
      this.selectedDomain = this.searchDomains[index]
    },
    saveHistory() {
      let queries = JSON.parse(localStorage.getItem('queries')) || []
      let validQuery

      if (this.searchQuery) {
        validQuery = this.searchQuery.trim()
        localStorage.setItem('latestQuery', validQuery)

        const existingIndex = queries.findIndex(
          item => item.query.toLowerCase() === validQuery.toLowerCase()
        )

        if (existingIndex !== -1) {
          queries.splice(existingIndex, 1)
        }

        const queryID = queries.length > 0 ? queries[queries.length - 1].id + 1 : 1

        const newQuery = {
          id: queryID,
          query: validQuery,
          timestamp: new Date().toISOString()
        }

        queries.push(newQuery)

        localStorage.setItem('queries', JSON.stringify(queries))

        this.queries = [...queries].reverse()
      }
    },

    showHistory() {
      this.isModalOpen = true
    },

    performSearch(q, domain) {
      if (domain === '') {
        domain = 'records'
      }
      this.saveHistory()
      this.$router.push({
        name: 'SearchResultsPage',
        query: {
          q: q.trim(),
          domain,
          useStringQuery: this.useStringQuery
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@use "#src/assets/scss/variables" as *;

.search-page.layout-centered {
  text-align: center;
  width: 100%;
  max-width: 76rem;
  padding: 5rem 1rem;
  margin: auto;
  @media screen and (width >= 47.5rem) and (height >= 40rem) {
    padding: 1rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
.search-page__title {
  font-size: 1.6875rem;
  @media screen and (width >= 47.5rem) {
    font-size: 2rem;
  }
}
/* stylelint-disable-next-line selector-class-pattern */
.f-field-search__dropdown {
  cursor: pointer;

  li[aria-selected="true"] {
    background-color: $light-blue;
  }
}

.search-page__content {
  display: flex;
  flex-direction: column;
}

.search-page__selector {
  flex: 0 0 25%;
  justify-self: left;
  > .f-field {
    margin: 0.5rem 0 1rem;
  }
}

.search-domain-selector {
  background-color: white;
  height: 3.5rem;
}

.search-page__search-area {
  flex-grow: 1;
  height: 3.5rem;
  > form {
    margin: 0.5rem 0 1rem;
  }
}

.top-container {
  text-align: left;
  > p {
    font-weight: 600;
    font-size: 1rem;
    line-height: 1.5;
    color: #2e3242;
  }
}

.middle-container {
  display: flex;
  justify-content: center;
  flex-direction: row;
  gap: 1rem;
  @media screen and (width <= 47.5rem) {
    flex-flow: column nowrap;
    gap: 0;
  }
}

.bottom-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  > .f-field {
    margin: 0.3rem 0 1rem;
  }
  @media screen and (width <= 47.5rem) {
    margin-top: 2rem;
    flex-flow: column nowrap;
    gap: 2rem;
    align-items: flex-start;
  }
}

.advanced-search {
  display: flex;
  gap: 0.2rem;
  flex-direction: row;
}

.advanced-search__text {
  align-self: center;
  font-weight: 600;
  font-size: 0.8rem;
  line-height: 1.5;
  color: #45555f;
}

.search-input {
  border: 0.0625rem solid $gray;
  box-shadow: none;
}

.history-list {
  display: flex;
  flex-flow: column nowrap;
  gap: 0.5rem;
  width: 100%;
}

.modal--xlg :deep(.modal__panel) {
  justify-content: flex-start;
}

.history-title {
  text-align: center;
  margin: 0;
}

.clearHistory {
  margin-left: auto;
  align-items: center;
  justify-content: center;
}

.clearHistory:hover {
  fill: $red;
}

.history-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 16px;
}

.history-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}

.history-item {
  display: flex;
  flex-flow: row nowrap;
  gap: 1rem;
  border-radius: 0.5rem;
  padding: 0.5rem;
  align-items: center;
  width: 100%;
}

.history-item:hover {
  background-color: $light-blue;
}

.history-btn {
  width: 2.5rem;
  height: 2.5rem
}

.delete-single-entry {
  background: none;
  border: none;
  padding: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.15s ease;
  flex-shrink: 0;
}

.delete-single-entry:hover {
  background-color: $light-blue;
}

.delete-single-entry:hover svg path {
  fill: $red;
}

.history-item__text {
  width: 70%;
}
</style>
